import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import type { CustomBillingPlan } from '@core/billing-types';

import { AssignedProductMessageComponent } from './assigned-product-message.component';
import { AssignedProductService } from '../../services/assigned-product.service';

@Component({
  selector: 'rt-assigned-product-message-container',
  template: `
    @if (assignedProduct) {
      <rt-assigned-product-message [disabled]="disabled()" (finishOrder)="finishOrder()" />
    }
  `,
  styleUrls: ['./assigned-product-message-container.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AssignedProductMessageComponent],
})
export class AssignedProductMessageContainerComponent {
  private readonly service = inject(AssignedProductService);
  private readonly cdRef = inject(ChangeDetectorRef);

  private readonly destroyRef = inject(DestroyRef);
  public readonly disabled = input(false);

  public assignedProduct: CustomBillingPlan | undefined;

  public ngOnInit() {
    this.service.data$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(product => {
      this.assignedProduct = product;
      this.cdRef.detectChanges();
    });
  }

  public finishOrder() {
    this.service.goToBilling();
  }
}
